import React from 'react'
import { useIntl } from 'react-intl'
import { Navigate, useLocation } from 'react-router-dom'
import LoadingSpinner from '../../../components/LoadingSpinner'
import { useEntryPointRouting } from '../../consent/hooks/useEntryPointRouting'

interface EntryPointGuardProps {
  children: React.ReactNode
}

/** Return true when the user should be redirected to ``redirectTo``. */
export function shouldEntryPointRedirect(pathname: string, redirectTo: string): boolean {
  if (pathname === redirectTo) return false
  if (redirectTo === '/intro' && pathname.startsWith('/consents')) return false
  return true
}

const EntryPointGuard: React.FC<EntryPointGuardProps> = ({ children }) => {
  const intl = useIntl()
  const location = useLocation()
  const { loading, redirectTo } = useEntryPointRouting()

  if (loading) {
    return <LoadingSpinner label={intl.formatMessage({ id: 'home.loading', defaultMessage: 'Loading...' })} />
  }

  if (redirectTo && shouldEntryPointRedirect(location.pathname, redirectTo)) {
    return <Navigate to={redirectTo} state={location.state} replace />
  }

  return <>{children}</>
}

export default EntryPointGuard
